import { render, staticRenderFns } from "./HomeDesktop.vue?vue&type=template&id=246034fc&scoped=true&"
import script from "./HomeDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HomeDesktop.vue?vue&type=style&index=0&id=246034fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246034fc",
  null
  
)

export default component.exports